export default "__VITE_ASSET__DX0mcj4F__"